import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";

export const IMU_PERCENTAGE = ({ factoryOptions, getterParams }) => {
    const retailFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.TOTAL_RETAIL } };
    const retailPlanRows = SIMPLE_SUM({ factoryOptions: retailFactoryOptions, getterParams });
    const costFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.TOTAL_COST } };
    const costPlanRows = SIMPLE_SUM({ factoryOptions: costFactoryOptions, getterParams });

    if (retailPlanRows > 0 && costPlanRows > 0) {
        return ((retailPlanRows - costPlanRows) / retailPlanRows) * 100;
    }

    return 0;
};
